<template>
  <div>
    <Table
      :no-data-text="$t('common.noData')"
      :columns="columns"
      :data="tableData"
      style="width: 100.1%"
    ></Table>
    <br />
    <Page
      :current="current"
      :total="dataTotal"
      show-sizer
      :page-size="pageSize"
      @on-change="changePage"
      @on-page-size-change="changeSize"
      :transfer="true"
    ></Page>
  </div>
</template>
<script>
let self = {};
export default {
  name: "TableRedisResource",
  data() {
    return {
      current: 1,
      dataTotal: 0,
      pageSize: 10,
      columns: [
        {
          title: this.$t("RAM.TENCENT.REDIS.accountName"),
          key: "accountName"
        },
        {
          title: this.$t("RAM.TENCENT.REDIS.instanceId"),
          key: "instanceId"
        },
        {
          title: this.$t("RAM.TENCENT.REDIS.instanceName"),
          key: "instanceName"
        },
        {
          title: this.$t("RAM.TENCENT.REDIS.region"),
          key: "regionName"
        },
        {
          title: this.$t("RAM.TENCENT.REDIS.zone"),
          key: "zone"
        },
        {
          title: this.$t("RAM.TENCENT.REDIS.statusName"),
          key: "statusName"
        },
        {
          title: this.$t("RAM.TENCENT.REDIS.vip"),
          key: "vip"
        },
        {
          title: this.$t("RAM.TENCENT.REDIS.port"),
          key: "port"
        },
        {
          title: this.$t("RAM.TENCENT.REDIS.size"),
          key: "size"
        },
        {
          title: this.$t("RAM.TENCENT.REDIS.productType"),
          key: "productType"
        },
        {
          title: this.$t("RAM.TENCENT.REDIS.engineVersion"),
          key: "engineVersion"
        },
        {
          title: this.$t("RAM.TENCENT.REDIS.createTime"),
          key: "createTime"
        }
      ],
      tableData: []
    };
  },
  created() {
    this._handleCompanyId = val => { this.companyId = val; };
    this._handleAccountSearchKey = val => { this.accountSearchKey = val; };
    this._handleAccountName = val => { this.accountName = val; };
    this._handleInstanceId = val => { this.instanceId = val; };
    eventBus.$on("companyId", this._handleCompanyId);
    eventBus.$on("accountSearchKey", this._handleAccountSearchKey);
    eventBus.$on("accountName", this._handleAccountName);
    eventBus.$on("instanceId", this._handleInstanceId);
    self = this;
  },
  methods: {
    showAll() {
      self.current = 1;
      self.getData();
    },
    getData() {
      self.$api.resourceManagement
        .selectTencentRedisByPage({
          companyId: self.companyId,
          accountName: self.accountName,
          instanceId: self.instanceId,
          accountIdList: self.accountSearchKey,
          pageNum: self.current,
          pageSize: self.pageSize
        })
        .then(res => {
          this.tableData = res.data.records;
          this.current = res.data.current;
          this.dataTotal = res.data.total;
        });
    },
    changePage(current) {
      this.current = current;
      this.getData();
    },
    changeSize(pageSize) {
      this.pageSize = pageSize;
      this.getData();
    }
  },
  beforeDestroy() {
    eventBus.$off("companyId", this._handleCompanyId);
    eventBus.$off("accountSearchKey", this._handleAccountSearchKey);
    eventBus.$off("accountName", this._handleAccountName);
    eventBus.$off("instanceId", this._handleInstanceId);
  }
};
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/configuration/resource_configuration_management/tencent/redis/TableRedisResource.vue